import { useVideoContext } from '../../../hooks/use-video';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Form, Space, Typography } from 'antd';
import {
  FormInput,
  FormSelectTags,
  FormTextArea,
} from '@monorepo/react-components';
import { Video } from '@monorepo/types';
import CopyText from '../../../components/copy-text/copy-text';

const VideoMetadata = () => {
  const { t } = useTranslation();
  const { video, updateMetadata } = useVideoContext();
  const form = useForm<Pick<Video, 'title' | 'description' | 'hashtags'>>({
    defaultValues: {
      title: '',
      description: '',
      hashtags: [],
    },
  });
  const {
    formState: { errors },
  } = form;

  useEffect(() => {
    if (video) {
      form.reset({
        title: video.title || '',
        description: video.description || '',
        hashtags: video.hashtags || '',
      });
    }
  }, [video?._id]);

  useEffect(() => {
    const { unsubscribe } = form.watch((value) => {
      if (video) {
        const hashtags = value.hashtags || video.hashtags;
        const cleanHashtags = hashtags.filter((tag) => tag !== undefined);

        updateMetadata({
          title: value.title || video.title,
          description: value.description || video.description,
          hashtags: cleanHashtags,
        });
      }
    });
    return () => unsubscribe();
  }, [form.watch]);

  const onSubmit = (data) => {
    console.log('Form data:', data);
  };

  return (
    <div className="video-metadata">
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <span>
            {t('videoEditor.metadata.titleLabel')}
            <CopyText text={form.getValues('title') || ''} />
          </span>
          <FormTextArea
            form={form}
            controllerProps={{
              name: 'title',
            }}
            placeholder={t('videoEditor.metadata.titlePlaceholder')}
            textareaProps={{
              maxLength: 100,
              showCount: true,
              autoSize: true,
              status: errors.description ? 'error' : undefined,
            }}
          />

          <span>
            <div>
              {t('videoEditor.metadata.descriptionLabel')}
              <CopyText text={form.getValues('description') || ''} />
            </div>
            <Typography.Text
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '12px',
                margin: 0,
              }}
              type={'secondary'}
            >
              <div>{t('videoEditor.metadata.descriptionNote')}</div>
              <div>{t('videoEditor.metadata.tiktokLimit')}</div>
            </Typography.Text>
          </span>
          <FormTextArea
            form={form}
            controllerProps={{
              name: 'description',
            }}
            placeholder={t('videoEditor.metadata.descriptionPlaceholder')}
            textareaProps={{
              rows: 12,
              maxLength: 5000,
              showCount: true,
              status: errors.description ? 'error' : undefined,
            }}
          />
          <span>
            <div>
              {t('videoEditor.metadata.hashtagsLabel')}
              <CopyText
                text={
                  form
                    .getValues('hashtags')
                    .map((tag) => {
                      return tag[0] === '#' ? tag : `#${tag}`;
                    })
                    .join(' ') || ''
                }
              />
            </div>
            <Typography.Text
              style={{ fontSize: '12px', margin: 0 }}
              type={'secondary'}
            >
              {t('videoEditor.metadata.hashtagsHint')}
            </Typography.Text>
          </span>
          <FormSelectTags
            form={form}
            maxCount={6}
            controllerProps={{
              name: 'hashtags',
            }}
            options={form
              .watch('hashtags')
              .map((tag) => ({ value: tag, label: tag }))}
          />
        </Space>
      </form>
    </div>
  );
};

export default VideoMetadata;
